import { http, fallback } from 'wagmi'

/**
 * viem の transport を構築する。
 * - 両方未設定時は `http()` (viem チェーン既定の RPC にフォールバック)
 * - プライマリのみ設定時は `http(primaryUrl)`
 * - 両方設定時は viem の `fallback()` で直列フェイルオーバー
 */
export function buildTransport(primaryUrl?: string, fallbackUrl?: string) {
  const urls = [primaryUrl, fallbackUrl].filter(
    (url): url is string => typeof url === 'string' && url.length > 0
  )
  if (urls.length === 0) return http()
  if (urls.length === 1) return http(urls[0])
  return fallback(urls.map((url) => http(url)))
}
